// src/components/BustSilhouette.jsx
//
// The in-play placeholder for BOTH Name That Guy games. Deliberately ONE
// component so Jr. and Sr. cannot drift apart visually.
//
// Why generic rather than per-player: Sr. used to silhouette the real photo
// with filter: brightness(0). That only produces a person-shaped cutout for
// transparent-background images (ESPN combiner headshots). Any manually
// uploaded photo with a real background renders as a solid black rectangle -
// which is what Celeb Saturday and wildcard days would be. A generic bust
// works with every puzzle and never leaks the answer image into the DOM
// mid-game.
//
// Sizing: fills its parent frame. The wrapper background matches the SVG's own
// background so the letterboxed edges (viewBox is 200x145, frames are wider)
// blend instead of showing lighter bands.

import React from 'react';

export default function BustSilhouette({ className = '', style = {} }) {
  return (
    <div
      className={className}
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#111b30',
        border: '1px solid #2a3a55',
        borderRadius: '4px',
        overflow: 'hidden',
        boxSizing: 'border-box',
        ...style,
      }}
    >
      <svg
        viewBox="0 0 200 145"
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: '100%', height: '100%' }}
        aria-hidden="true"
      >
        <rect width="200" height="145" fill="#111b30" />
        <g fill="#05080f">
          {/* Head */}
          <ellipse cx="100" cy="50" rx="25" ry="29" />
          {/* Neck + sloping shoulders */}
          <path d="M100 82 C72 82 50 101 45 145 L155 145 C150 101 128 82 100 82 Z" />
        </g>
      </svg>
    </div>
  );
}
